package com.vizio.redwolf.auth.config

import com.vizio.redwolf.auth.api.CreatePinResponse
import com.vizio.redwolf.auth.api.DeletePinResponse
import com.vizio.redwolf.auth.api.HasPinResponse
import com.vizio.redwolf.auth.api.UpdatePinResponse
import com.vizio.redwolf.auth.api.ValidatePinResponse
import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic

object PinApiJsonConfig {

    val config = Json {
        serializersModule = SerializersModule {
            polymorphic(HasPinResponse::class) {
                subclass(HasPinResponse.PinFound::class, HasPinResponse.PinFound.serializer())
                subclass(HasPinResponse.PinNotFound::class, HasPinResponse.PinNotFound.serializer())
                subclass(HasPinResponse.UserIdNotFound::class, HasPinResponse.UserIdNotFound.serializer())
                subclass(HasPinResponse.InvalidBasicAuthCredentials::class, HasPinResponse.InvalidBasicAuthCredentials.serializer())
                subclass(HasPinResponse.Failure::class, HasPinResponse.Failure.serializer())
                default { HasPinResponse.BadPayload.serializer() }
            }
            polymorphic(CreatePinResponse::class) {
                subclass(CreatePinResponse.Success::class, CreatePinResponse.Success.serializer())
                subclass(CreatePinResponse.UserIdNotFound::class, CreatePinResponse.UserIdNotFound.serializer())
                subclass(CreatePinResponse.InvalidBasicAuthCredentials::class, CreatePinResponse.InvalidBasicAuthCredentials.serializer())
                subclass(CreatePinResponse.PayPinRequired::class, CreatePinResponse.PayPinRequired.serializer())
                subclass(CreatePinResponse.PinReused::class, CreatePinResponse.PinReused.serializer())
                subclass(CreatePinResponse.Failure::class, CreatePinResponse.Failure.serializer())
                default { CreatePinResponse.BadPayload.serializer() }
            }
            polymorphic(ValidatePinResponse::class) {
                subclass(ValidatePinResponse.ValidPin::class, ValidatePinResponse.ValidPin.serializer())
                subclass(ValidatePinResponse.UserIdNotFound::class, ValidatePinResponse.UserIdNotFound.serializer())
                subclass(ValidatePinResponse.FlowIdNotFound::class, ValidatePinResponse.FlowIdNotFound.serializer())
                subclass(ValidatePinResponse.InvalidPin::class, ValidatePinResponse.InvalidPin.serializer())
                subclass(ValidatePinResponse.PinLocked::class, ValidatePinResponse.PinLocked.serializer())
                subclass(ValidatePinResponse.PinNotFound::class, ValidatePinResponse.PinNotFound.serializer())
                subclass(ValidatePinResponse.TooManyRequests::class, ValidatePinResponse.TooManyRequests.serializer())
                subclass(ValidatePinResponse.Failure::class, ValidatePinResponse.Failure.serializer())
                subclass(ValidatePinResponse.PayPinRequired::class, ValidatePinResponse.PayPinRequired.serializer())
                default { ValidatePinResponse.BadPayload.serializer() }
            }

            polymorphic(UpdatePinResponse::class) {
                subclass(UpdatePinResponse.Success::class, UpdatePinResponse.Success.serializer())
                subclass(UpdatePinResponse.Failure::class, UpdatePinResponse.Failure.serializer())
                subclass(UpdatePinResponse.PayPinRequired::class, UpdatePinResponse.PayPinRequired.serializer())
                subclass(UpdatePinResponse.UserIdNotFound::class, UpdatePinResponse.UserIdNotFound.serializer())
                subclass(UpdatePinResponse.InvalidBasicAuthCredentials::class, UpdatePinResponse.InvalidBasicAuthCredentials.serializer())
                subclass(UpdatePinResponse.PinReused::class, UpdatePinResponse.PinReused.serializer())
                default { UpdatePinResponse.BadPayload.serializer() }
            }

            polymorphic(DeletePinResponse::class) {
                subclass(DeletePinResponse.Success::class, DeletePinResponse.Success.serializer())
                subclass(DeletePinResponse.Failure::class, DeletePinResponse.Failure.serializer())
                subclass(DeletePinResponse.UserIdNotFound::class, DeletePinResponse.UserIdNotFound.serializer())
                subclass(DeletePinResponse.InvalidBasicAuthCredentials::class, DeletePinResponse.InvalidBasicAuthCredentials.serializer())
                subclass(DeletePinResponse.PinNotFound::class, DeletePinResponse.PinNotFound.serializer())
                default { DeletePinResponse.BadPayload.serializer() }
            }
        }
        coerceInputValues = true
        isLenient = true
        ignoreUnknownKeys = true
        encodeDefaults = true
        prettyPrint = true
        classDiscriminator = "status"
    }

}